import { useRef, useState } from "react";

export const useToggle = <T extends HTMLElement>(height: number) => {
  const targetRef = useRef<T>(null);
  const [isOpenToggle, setIsOpenToggle] = useState(false);

  const handleOnToggle = () => {
    if (!targetRef.current) return;
    if (!isOpenToggle) {
      targetRef.current.style.height = `${height}px`;
    } else {
      targetRef.current.style.height = "0px";
    }
    setIsOpenToggle((prev) => !prev);
  };

  const closeToggle = () => {
    if (!targetRef.current) return;
    targetRef.current.style.height = "0px";
    setIsOpenToggle(false);
  };

  return { targetRef, handleOnToggle, isOpenToggle, closeToggle };
};
